document.addEventListener('DOMContentLoaded', () => {
  const modal = document.createElement('div');
  modal.id = 'image-modal';
  modal.className = 'hidden image-modal';
  modal.innerHTML = `
    <div class="image-modal__content">
      <div class="image-modal__carousel">
        <button class="image-modal__prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left ltr-icon"><title></title><polyline points="15 18 9 12 15 6"></polyline></svg>
        </button>
        <img class="image-modal__image" src="" alt="">
        <button class="image-modal__next">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right ltr-icon"><title></title><polyline points="9 18 15 12 9 6"></polyline></svg>
        </button>
      </div>
      <div class="image-modal__thumbnails"></div>
    </div>
    <button class="image-modal__close"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><title></title><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>
  `;
  document.body.appendChild(modal);

  const modalImage = modal.querySelector('.image-modal__image');
  const closeButton = modal.querySelector('.image-modal__close');
  const prevButton = modal.querySelector('.image-modal__prev');
  const nextButton = modal.querySelector('.image-modal__next');
  const carouselImages = [...document.querySelectorAll('[data-media-id] img')]; // Open modal element;
  const thumbnailsContainer = modal.querySelector('.image-modal__thumbnails');

  let currentImageIndex = 0;
  let scale = 0.6;
  let translateX = 0;
  let translateY = 0;

  let touchStartX = 0;
  let touchEndX = 0;

  const updateModalImage = () => {
    const imageSrc = carouselImages[currentImageIndex]?.src;
    if (imageSrc) {
      modalImage.src = imageSrc;
      scale = 0.6; // Reset zoom when touch image
      modalImage.style.transform = `scale(${scale})`;
      updateSelectedThumbnail();
    }
  };

  const updateSelectedThumbnail = () => {
    const thumbnails = document.querySelectorAll('.image-modal__thumbnail');
    thumbnails.forEach((thumbnail, index) => {
        if (index === currentImageIndex) {
            thumbnail.classList.add('selected');
            // Opcional: Rolar a thumbnail selecionada para o centro
            thumbnailsContainer.scrollLeft = thumbnail.offsetLeft - (thumbnailsContainer.offsetWidth - thumbnail.offsetWidth) / 2;
        } else {
            thumbnail.classList.remove('selected');
        }
    });
  };

  const openModal = (index) => {
    currentImageIndex = index;
    updateModalImage();
    modal.classList.remove('hidden');
  };

  const closeModal = () => {
    modal.classList.add('hidden');
  };

  const showNextImage = () => {
    currentImageIndex = (currentImageIndex + 1) % carouselImages.length;
    updateModalImage();
  };

  const showPrevImage = () => {
    currentImageIndex = (currentImageIndex - 1 + carouselImages.length) % carouselImages.length;
    updateModalImage();
  };

  const handleTouchStart = (event) => {
    touchStartX = event.touches[0].clientX;
  };
  const handleTouchMove = (event) => {
    touchEndX = event.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    const touchDifference = touchStartX - touchEndX;
    if (touchDifference > 50) {
      // Swipe Left
      showNextImage();
    } else if (touchDifference < -50) {
      // Swipe right
      showPrevImage();
    }
    touchStartX = 0;
    touchEndX = 0;
  };

  modalImage.addEventListener('wheel', (event) => {
    event.preventDefault();
    scale += event.deltaY * -0.001;
    scale = Math.min(Math.max(0.6, scale), 2); // Zoom limit 1x - 3x
    modalImage.style.transform = `scale(${scale})`;
  });

  closeButton.addEventListener('click', closeModal);
  prevButton.addEventListener('click', showPrevImage);
  nextButton.addEventListener('click', showNextImage);

  modal.addEventListener('click', (event) => {
    if (!event.target.closest('.image-modal__content')) closeModal();

    modalImage.style.transform = `scale(${scale})`;
  });

  modalImage.addEventListener('click', () => {
    if (scale <= 0.7) {
      scale = 2;
    } else {
      scale = 0.6;
    }
    modalImage.style.transform = `scale(${scale})`;
  });


  carouselImages.forEach((image, index) => {
    image.addEventListener('click', () => openModal(index));
  });

  // modalImage.addEventListener('touchstart', handleTouchStart);
  // modalImage.addEventListener('touchmove', handleTouchMove);
  // modalImage.addEventListener('touchend', handleTouchEnd);

  // Adicionar Thumbnails Dinamicamente
  carouselImages.forEach((image, index) => {
    const thumbnail = document.createElement('img');
    thumbnail.src = image.src; // Usar a mesma fonte da imagem original
    thumbnail.alt = `Thumbnail ${index + 1}`;
    thumbnail.className = 'image-modal__thumbnail';
    thumbnail.addEventListener('click', () => {
      openModal(index);
    });
    thumbnailsContainer.appendChild(thumbnail);
  });

  updateSelectedThumbnail();

  document.addEventListener('mousemove', (event) => {
    if (!isDragging) return;

    const imageWidth = modalImage.offsetWidth * scale;
    const imageHeight = modalImage.offsetHeight * scale;
    const containerWidth = modalImage.parentElement.offsetWidth;
    const containerHeight = modalImage.parentElement.offsetHeight;

    let newTranslateX = event.clientX - startX;
    let newTranslateY = event.clientY - startY;

    // Limitar o arrasto horizontalmente
    if (imageWidth > containerWidth) {
        const minX = containerWidth - imageWidth;
        const maxX = 0;
        newTranslateX = Math.max(minX, Math.min(maxX, newTranslateX));
    } else {
        newTranslateX = 0; // Centralizar se a imagem for menor que o container
    }

    // Limitar o arrasto verticalmente
    if (imageHeight > containerHeight) {
        const minY = containerHeight - imageHeight;
        const maxY = 0;
        newTranslateY = Math.max(minY, Math.min(maxY, newTranslateY));
    } else {
        newTranslateY = 0; // Centralizar se a imagem for menor que o container
    }

    translateX = newTranslateX;
    translateY = newTranslateY;

    modalImage.style.transform = `scale(${scale}) translate(${translateX}px, ${translateY}px)`;
});

document.addEventListener('mouseup', () => {
    isDragging = false;
    modalImage.style.cursor = 'grab';
});

modalImage.addEventListener('mouseleave', () => {
    if (isDragging) {
        isDragging = false;
        modalImage.style.cursor = 'grab';
    }
});


});
